import {
  CUSTOM_OPERATORS_ENUM,
  INTERNAL_CUSTOM_OPERATORS_ENUM,
  JSON_LOGIC_OPERATORS,
  UTILITY_OPERATORS_ENUM,
} from '@nirmata/shared';

// Define the schema for conditional rules
// AUTO-GENERATED: Explicit schema for all supported operators for Monaco JSON suggestions
export const conditionalRulesSchema = {
  type: 'array',
  items: { $ref: '#/$defs/condition' },
  $defs: {
    condition: {
      type: 'object',
      properties: [
        ...Object.values(JSON_LOGIC_OPERATORS),
        ...Object.values(UTILITY_OPERATORS_ENUM),
        ...Object.values(CUSTOM_OPERATORS_ENUM),
        ...Object.values(INTERNAL_CUSTOM_OPERATORS_ENUM),
      ].reduce(
        (acc, key) => {
          // Define the schema for each operator
          if (
            [...Object.values(JSON_LOGIC_OPERATORS), ...Object.values(UTILITY_OPERATORS_ENUM)]
              .map(String)
              .includes(String(key))
          ) {
            acc[String(key)] = { type: 'array', items: { $ref: '#/$defs/conditionOrValue' } };
          } else if (
            [
              ...Object.values(CUSTOM_OPERATORS_ENUM),
              ...Object.values(INTERNAL_CUSTOM_OPERATORS_ENUM),
            ]
              .map(String)
              .includes(String(key))
          ) {
            // Custom/internal operators flexible schema
            acc[String(key)] = {
              anyOf: [
                { type: 'string' },
                { type: 'object', additionalProperties: true },
                { type: 'array', items: { $ref: '#/$defs/conditionOrValue' } },
              ],
            };
          }
          return acc;
        },
        {} as { [key: string]: any }
      ),
      additionalProperties: false,
    },
    // This allows a value or another condition (for recursion)
    conditionOrValue: {
      anyOf: [
        { $ref: '#/$defs/condition' },
        { type: 'string' },
        { type: 'number' },
        { type: 'boolean' },
        { type: 'object' },
        { type: 'array' },
        { type: 'null' },
      ],
    },
  },
};
